import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("CookeiOptionsWidget", {
  title: "Cookie options",
});
